// src/services/api/authService.js
import apiClient from "../../utils/apiClient"; // Adjust path based on your structure

// Send OTP - First step
export const SignIn = (mobileNumber) => {
  return apiClient.post('/auth/consumer/login', {
    phoneNumber: mobileNumber,
  });
};

export const RefreshToken = (refreshToken) => {
  return apiClient.post('/auth/refresh', {
    refreshToken: refreshToken,
  });
}

// Verify OTP - Second step
export const VerifyOTP = (mobileNumber, otp, otpRef) => {
  return apiClient.post('/auth/consumer/verify', {
    phoneNumber: mobileNumber,
    otp: otp,
    deviceToken: "dzQV7wokSTGGYBLYfnSSzt:APA91bFjrXfUpiefmoINz-tAPsTAsOrtDspbnvoCtLCGQUmDbyMn_aBiYi86-TXTcqRlZqhi2gLFmFwC2-hheWWBJF4OqpwRTYpG1wf4nsyVtuteoT-qeIo"
  });
};

// Resend OTP
export const ResendOTP = (mobileNumber) => {
  return apiClient.post('/auth/consumer/login', {
    phoneNumber: mobileNumber,
  });
};

export const SignOut = (refreshToken) => {
  return apiClient.post('/auth/logout', {
    refreshToken: refreshToken,
  });
};